import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { IGameEnvironment } from '../../../model/gameEnvironment/GameEnvironment';
import { GameEnvironmentForm } from './gameEnvironmentForm';
import { Card } from 'react-bootstrap';

export interface GameEnvironmentCardProps {
    gameEnvironment: IGameEnvironment;
    updateCallbackTrigger: (clearActiveGameEnvironment?: boolean) => void;
}

export const GameEnvironmentCard: FC<GameEnvironmentCardProps> = observer((props: GameEnvironmentCardProps) => {

    return (
        <Card key={props.gameEnvironment.id} className={'m3Card'}>
            <Card.Body className={'cardBody'}>
                <GameEnvironmentForm gameEnvironment={props.gameEnvironment}
                                     updateCallbackTrigger={props.updateCallbackTrigger} />
            </Card.Body>
        </Card>
    );
});
